// media-library-image/media-library-image.js

import MediaLibraryImageEditing from './media-library-image-editing';
import MediaLibraryImageUI from './media-library-image-ui';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class MediaLibraryImage extends Plugin {
    static get requires() {
        return [ MediaLibraryImageEditing, MediaLibraryImageUI ];
    }
}
